var exports = {
  "Qs": "GiftAcceptModal.module__content___OXctZj",
  "O8": "GiftAcceptModal.module__loadingContent___OXctZj",
  "Nr": "GiftAcceptModal.module__card___OXctZj",
  "$2": "GiftAcceptModal.module__cardGrid___OXctZj",
  "kJ": "GiftAcceptModal.module__iconCircle___OXctZj",
  "SP": "GiftAcceptModal.module__iconCircleActive___OXctZj",
  "PP": "GiftAcceptModal.module__iconCircleInactive___OXctZj",
  "_O": "GiftAcceptModal.module__iconCircleDisabled___OXctZj",
  "Kk": "GiftAcceptModal.module__icon___OXctZj",
  "m5": "GiftAcceptModal.module__iconError___OXctZj",
  "Ux": "GiftAcceptModal.module__cardContent___OXctZj",
  "DD": "GiftAcceptModal.module__title___OXctZj",
  "jn": "GiftAcceptModal.module__titlePrimary___OXctZj",
  "xP": "GiftAcceptModal.module__titleTertiary___OXctZj",
  "S3": "GiftAcceptModal.module__titleDanger___OXctZj",
  "VA": "GiftAcceptModal.module__subtitle___OXctZj",
  "BK": "GiftAcceptModal.module__helpText___OXctZj",
  "qr": "GiftAcceptModal.module__footer___OXctZj",
  "BS": "GiftAcceptModal.module__giftArtwork___OXctZj",
};

module.exports = exports;
